var React = require('react');

function Carryout (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M694,27.43H669.09V22.58A22.58,22.58,0,0,0,646.51,0H93.21A22.58,22.58,0,0,0,70.63,22.58v4.85H58.25A14.55,14.55,0,0,0,43.69,42V75.55H708.58V42A14.55,14.55,0,0,0,694,27.43Z","key":0}),React.createElement("path",{"d":"M514.07,281.42c93.14,0,145.1-45.05,159.15-143.91,7.5-17.67,35.36-31.32,35.36-31.33H41.3s27.63,13.55,35.26,31.11c14.08,98.44,66,144.13,159.14,144.13H0v42.8H747.39v-42.8Z","key":1})])));
}

Carryout.defaultProps = {"viewBox":"0 0 747.39 324.22"};

module.exports = Carryout;

Carryout.default = Carryout;
